import { MODULE_KEY } from '@/constants/modules';
import { useHasTenantPermission } from './useHasTenantPermission';
import { useHasWorkspaceModule } from './useHasWorkspaceModule';

export const ASSISTANT_USE_PERMISSION = 'assistant.use';

export function useIsAssistantAvailable(): boolean {
  const hasModule = useHasWorkspaceModule(MODULE_KEY.aiAssistant);
  const hasPermission = useHasTenantPermission(ASSISTANT_USE_PERMISSION);
  return hasModule && hasPermission;
}
